import { clamp } from '../../utils/clamp.js';
export const setDefaultParamsCalc = ({ field, defParams, calcParams, map, monthsValue = 'maxMonths', }) => {
    Object.entries(map).forEach(([key, value]) => {
        field?.(key)?.onChange?.(defParams?.[value]);
    });
    field?.('monthsValue')?.onChange?.(clamp(defParams?.[monthsValue], calcParams.minMonths, calcParams.maxMonths));
};
//# sourceMappingURL=setDefaultParamsCalc.js.map